import io from "socket.io-client";
import config from "config";
import history from "utils/history";
import { markSuccess, unmarkSuccess, skipSuccess } from "actions/dates";
import {
  fetchHabits,
  addHabitSuccess,
  editHabitSuccess,
  deleteHabitSuccess,
  changeHabitGroup,
} from "actions/habits";
import { updateUserSuccess } from "actions/auth";
import { updateStreak, calculateGroupStats } from "./stats";
import store from "../stores";

let socket;

export const getId = () => socket && socket.id;

export const connect = (id) => {
  if (socket) return;
  socket = io(`${config.apiUrl}`);

  socket.on("registrationRequest", () => {
    socket.emit("register", id);
  });

  socket.on("mark", (data) => {
    const state = store.getState();

    store.dispatch(markSuccess(data.date, state.habitsEntities[data.habit_id]));
    store.dispatch(updateStreak(data.habit_id));
  });

  socket.on("unmark", (data) => {
    const state = store.getState();

    store.dispatch(
      unmarkSuccess(data.date, state.habitsEntities[data.habit_id])
    );
    store.dispatch(updateStreak(data.habit_id));
  });

  socket.on("skip", (data) => {
    const state = store.getState();

    store.dispatch(skipSuccess(data.date, state.habitsEntities[data.habit_id]));
    store.dispatch(updateStreak(data.habit_id));
  });

  socket.on("addHabit", (data) => {
    const state = store.getState();
    if (!state.habitsEntities[data.id]) store.dispatch(addHabitSuccess(data));
  });

  socket.on("editHabit", (habit) => {
    const state = store.getState();
    const oldHabit = state.habitsEntities[habit.id];
    if (
      oldHabit.color !== habit.color ||
      oldHabit.break_habit !== habit.break_habit
    )
      store.dispatch({
        type: "UPDATE_HABIT_COLOR",
        habit,
      });
    if (oldHabit.archived && !habit.archived) {
      store.dispatch({
        type: "UNARCHIVE",
        id: habit.id,
      });
    }

    if (!oldHabit.archived && habit.archived) {
      store.dispatch({
        type: "ARCHIVE",
        id: habit.id,
      });

      if (habit.group_id) {
        store.dispatch(
          changeHabitGroup({
            habitId: habit.id,
            from: habit.group_id,
            to: null,
          })
        );
      }
    }

    store.dispatch(editHabitSuccess(habit));
  });

  socket.on("addGroup", (group) => {
    console.log("addGroup", group);
    store.dispatch({
      type: "ADD_GROUP",
      group,
    });
  });

  socket.on("editGroup", (group) => {
    console.log("editGroup", group);
    store.dispatch({
      type: "EDIT_GROUP",
      group,
    });
  });

  socket.on("deleteGroup", (groupId) => {
    store.dispatch({
      type: "DELETE_GROUP",
      groupId,
    });
  });

  socket.on("sortRows", (body) => {
    const state = store.getState();

    const userId = parseInt(body?.user_id, 10);
    const remoteRows = body?.rows;

    if (userId !== state.user.id) return;

    if (remoteRows.length !== state.rows.length) return;

    // Check if remote and local have the same row IDs regardless of order
    const localIds = new Set(state.rows.map((row) => row.id));
    const remoteIds = new Set(remoteRows.map((row) => row.id));
    const haveSameRows = [...localIds].every((id) => remoteIds.has(id));

    if (!haveSameRows) return;

    for (const row of remoteRows) {
      if (row.isHabit) {
        const habit = state.habitsEntities[row.id];
        if (!habit) return;
        const groupId = row.group_id ? parseInt(row.group_id, 10) : null;
        if (habit.group_id !== groupId) {
          store.dispatch(
            changeHabitGroup({
              habitId: habit.id,
              from: habit.group_id,
              to: groupId,
            })
          );
        }
      }
    }

    store.dispatch({ type: "SET_ROWS", rows: remoteRows });
  });

  socket.on("moveHabit", () => {
    store.dispatch(fetchHabits());
  });

  socket.on("deleteHabit", (habitId) => {
    const state = store.getState();
    if (!state.habitsEntities[habitId]) return;
    if (state.habitsEntities[habitId].group_id) {
      store.dispatch({
        type: "REMOVE_HABIT_FROM_GROUP",
        groupId: state.habitsEntities[habitId].group_id,
      });
    }
    store.dispatch(deleteHabitSuccess(habitId));
  });

  socket.on("updateUser", (user) => {
    store.dispatch(updateUserSuccess(user));
    history.replace("/");
  });
};
